import React from "react";
import { motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/layout/ThemeProvider";

const ThemeToggle = () => {
  const { theme, cycleTheme } = useTheme();
  const isDark = theme === "dark";
  const NextIcon = isDark ? Sun : Moon;
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";

  return (
    <motion.button
      type="button"
      onClick={cycleTheme}
      aria-label={label}
      title={label}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-4 sm:right-6 z-[60] w-11 h-11 rounded-full btn-glass flex items-center justify-center shadow-lg"
    >
      <motion.div
        key={theme}
        initial={{ rotate: -90, opacity: 0 }}
        animate={{ rotate: 0, opacity: 1 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        <NextIcon className="w-5 h-5" />
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;
